import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Avatar from '../../../shared/components/Avatar';

class AgencyNavBar extends Component {
  constructor(){
    super();

    this.state = {
      profileMenuIsOpen:false,
      mobileMenuIsOpen:false
    };
  }

  render(){
    const {
      currentURL,
      userIsAdmin,
      onSignOutClick,
      profileMenuIsForcedOpen,
      avatarUserName,
      avatarURL,
      agencyName,
      isDashboard,
      build
    } = this.props;

    const {
      profileMenuIsOpen
    } = this.state;

    return (
      <Navbar
        style={{
          padding:'0px 60px 0px 30px',
          backgroundColor:isDashboard ? '#edf4fb' : 'inherit',
          color:'#101010',
          borderBottom:isDashboard ? '':'1px solid #e4e4e4'
        }}
        className='HorizontalNavBar no-print'
        expand='xs'
      >
        <NavbarBrand
          tag={Link}
          to={`${currentURL}/experiences`}
        >
          <img
            src={require('../../../shared/assets/dd-logo.png')}
            alt='Adjoy'
            style={{height:30,marginRight:10}}
          />
          <span
            style={{
              fontSize:14,
              marginLeft:15,
              color: 'rgba(0,0,0,.6)'
            }}
          >
            {agencyName}
          </span>
        </NavbarBrand>
        <Nav navbar className='ml-auto'>
          <NavItem className='NonUserNameNavItem'>
            <NavLink
              tag={Link}
              to={`${currentURL}/experiences`}
              activeClassName='active'
            >
              &nbsp;&nbsp;Experiences
            </NavLink>
          </NavItem>
          <NavItem className='NonUserNameNavItem'>
            <NavLink
              tag={Link}
              to={`${currentURL}/audience`}
              activeClassName='active'
            >
              &nbsp;&nbsp;The Downtime Dollars Audience
            </NavLink>
          </NavItem>
          <NavItem className='NonUserNameNavItem'>
            <NavLink
              tag={Link}
              to={`${currentURL}/brands`}
              activeClassName='active'
            >
              &nbsp;&nbsp;Brands
            </NavLink>
          </NavItem>
          <NavItem className='NonUserNameNavItem'>
            <NavLink
              tag={Link}
              to={`${currentURL}/help/faqs`}
              activeClassName='active'
            >
              &nbsp;&nbsp;Help
            </NavLink>
          </NavItem>
          <Dropdown
            nav
            inNavbar
            isOpen={profileMenuIsOpen || profileMenuIsForcedOpen}
            toggle={() => this.setState({profileMenuIsOpen:!profileMenuIsOpen})}
            className='UserNameNavItem ProfileDropdown'
          >
            <DropdownToggle nav caret>
              <Avatar
                userName={avatarUserName}
                imageUrl={avatarURL}
              />
              &nbsp;&nbsp;
            </DropdownToggle>
            <DropdownMenu className='dropdown-menu-right ProfileDropdownMenu'>
              <DropdownItem
                tag={Link}
                to={`${currentURL}/profile`}
                exact
              >
                My Profile
              </DropdownItem>
              <DropdownItem
                tag={Link}
                to={`${currentURL}/users`}
                hidden={!userIsAdmin}
                exact
              >
                Manage Team
              </DropdownItem>
              <DropdownItem
                tag={Link}
                to={`${currentURL}/brands`}
              >
                Manage Brands
              </DropdownItem>
              <DropdownItem
                tag={Link}
                to={`${currentURL}/account`}
                hidden={!userIsAdmin}
                exact
              >
                Manage Account
              </DropdownItem>
              <DropdownItem divider></DropdownItem>
              <DropdownItem
                onClick={() => onSignOutClick()}
              >
                Sign Out
              </DropdownItem>
              <DropdownItem divider></DropdownItem>
              <DropdownItem disabled>
                {build}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Nav>
      </Navbar>
    );
  }
}

AgencyNavBar.defaultProps = {
  onSignOutClick:() => {},
  userIsAdmin:false,
  profileMenuIsForcedOpen:false,
  avatarUserName:'Downtime Dollars User',
  agencyName:'Downtime Dollars Agency',
  currentURL:''
};

AgencyNavBar.propTypes = {
  onSignOutClick:PropTypes.func.isRequired,
  userIsAdmin:PropTypes.bool.isRequired,
  profileMenuIsForcedOpen:PropTypes.bool.isRequired,
  avatarUserName:PropTypes.string.isRequired,
  avatarURL:PropTypes.string,
  currentURL:PropTypes.string.isRequired,
  agencyName:PropTypes.string.isRequired
};

export default AgencyNavBar;



// WEBPACK FOOTER //
// ./src/routes/AgencyPortal/components/AgencyNavBar.js